import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=2a3becbc&"
import script from "./CartView.vue?vue&type=script&lang=js&"
export * from "./CartView.vue?vue&type=script&lang=js&"
import style0 from "./CartView.vue?vue&type=style&index=0&id=2a3becbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports